"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKMenu = void 0;
/* eslint-disable jsx-a11y/aria-activedescendant-has-tabindex */
// @TODO: fix jsx-a11y
var React = __importStar(require("react"));
var scroll_into_view_1 = __importDefault(require("scroll-into-view"));
var __1 = require("../../");
var common_1 = require("../../common");
var models_1 = require("../../models");
var GKMenuFooter_1 = require("./GKMenuFooter/GKMenuFooter");
var GKMenuGroup_1 = require("./GKMenuGroup/GKMenuGroup");
var GKMenuHeader_1 = require("./GKMenuHeader/GKMenuHeader");
var GKMenuItem_1 = require("./GKMenuItem/GKMenuItem");
var GKMenuLoading_1 = require("./GKMenuLoading/GKMenuLoading");
var react_popper_1 = require("react-popper");
require("./GKMenu.css");
/**
 * Floating menu containing one or more GKMenuItem, optionally organized via GKMenuGroup and/or containing a fixed GKMenuFooter.
 * Forms the basis for a number of higher order components, namely selects and auto-completes
 */
var GKMenu = /** @class */ (function (_super) {
    __extends(GKMenu, _super);
    function GKMenu(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.menuRef = React.createRef();
        // PUBLIC API -------------------------------------------
        /**
         * Focus the menu, if it doesn't already have focus
         */
        _this.focus = function () {
            if (!_this.state.hasFocus) {
                _this.setState({ pendingFocus: true });
            }
        };
        /** Move virtual focus to next menu item  */
        _this.next = function () {
            return _this.setState({ activeChild: _this.navigator.nextItem() });
        };
        /** Move virtual focus to previous menu item */
        _this.previous = function () {
            return _this.setState({ activeChild: _this.navigator.previousItem() });
        };
        /** Move virtual focus to the first menu item */
        _this.first = function () {
            _this.navigator.exit();
            _this.setState({ activeChild: _this.navigator.nextItem() });
        };
        /** Move virtual focus to the last menu item */
        _this.last = function () {
            _this.navigator.exit();
            _this.setState({ activeChild: _this.navigator.previousItem() });
        };
        /** Simulate selection on the current virtually focus item */
        _this.selectFocusedItem = function () {
            if (_this.state.activeChild) {
                _this.state.activeChild.select();
                _this.onItemSelected();
            }
        };
        /** Forcibly close the menu, returning focus to the anchor if menu is managing its own focus */
        _this.close = function () {
            _this.closeMenu();
            _this.returnFocusToAnchor();
        };
        // PRIVATE METHODS ----------------------------------------
        _this.menuListAvaialable = function (ref) {
            if (ref && _this.state.pendingFocus) {
                ref.focus({ preventScroll: true });
                _this.setState({ pendingFocus: false });
            }
        };
        _this.onMenuFocused = function (event) {
            _this.setState({ hasFocus: true });
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        // close menu if clicked, touched, or focused outside the component and we're managing our own focus --
        _this.onClickOutside = function (event) {
            return _this.closeIfOutsideComponent(event.target);
        };
        _this.onTouchend = function (event) {
            return _this.closeIfOutsideComponent(event.changedTouches[0].target);
        };
        _this.onMenuBlurred = function (event) {
            if (event.relatedTarget !== null) {
                _this.closeIfOutsideComponent(event.relatedTarget);
            }
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
            _this.setState({ hasFocus: false });
        };
        _this.closeIfOutsideComponent = function (target) {
            var shouldClose = Boolean(_this.state.isOpen &&
                _this.isManagingOwnFocus &&
                _this.menuRef.current &&
                !_this.menuRef.current.contains(target));
            if (shouldClose) {
                _this.closeMenu();
            }
        };
        // --
        _this.onItemSelected = function () {
            if (_this.closeOnSelect) {
                _this.closeMenu();
                _this.returnFocusToAnchor();
            }
        };
        _this.onLeave = function () {
            _this.setState({ activeChild: null });
        };
        _this.closeMenu = function () {
            if (!_this.state.isOpen) {
                return;
            }
            _this.setState({ activeChild: null, isOpen: false, hasFocus: false });
            if (_this.props.onClose) {
                _this.props.onClose();
            }
            _this.navigator.exit();
        };
        _this.openMenu = function () {
            // don't need to check state, because there is no public method which calls this method.
            _this.setState({ isOpen: true });
            if (_this.props.onOpen) {
                _this.props.onOpen();
            }
            if (_this.isManagingOwnFocus) {
                _this.focus();
            }
        };
        /**
         *  If the menu is managing its own focus, return focus to its anchor
         * TODO: provide document wrapper for unit testing
         */
        _this.returnFocusToAnchor = function () {
            var _a = _this.props, anchorRef = _a.anchorRef, anchoredTo = _a.anchoredTo;
            if (_this.isManagingOwnFocus) {
                if (anchorRef && anchorRef.current) {
                    anchorRef.current.focus({ preventScroll: true });
                }
                else {
                    window.setTimeout(function () {
                        if (anchoredTo) {
                            var element = document.getElementById(anchoredTo);
                            if (element) {
                                element.focus({ preventScroll: true });
                            }
                        }
                    }, 0);
                }
            }
        };
        /**
         * Verify children are correct types, categorize appropriately, and get relevant refs for navigation
         */
        _this.processChildren = function () {
            var menuItems = [];
            var headers = [];
            var footers = [];
            // categorize children into appropriate types
            React.Children.toArray(_this.props.children).forEach(function (c) {
                if (c.type === GKMenuItem_1.GKMenuItem || c.type === GKMenuGroup_1.GKMenuGroup) {
                    menuItems.push(c);
                }
                else if (c.type === GKMenuFooter_1.GKMenuFooter) {
                    footers.push(c);
                }
                else if (c.type === GKMenuHeader_1.GKMenuHeader) {
                    headers.push(c);
                }
            });
            // get references to children for keyboard navigation and/or accessibility and set up naviagtor
            var itemRefs = [];
            menuItems = menuItems.map(function (item) {
                return React.cloneElement(item, {
                    ref: function (ref) {
                        if (!item.props.disabled) {
                            itemRefs.push(ref);
                        }
                    },
                });
            });
            _this.pvtNavigator = new models_1.GroupNavigator(itemRefs, {
                onLeave: _this.onLeave,
                wrap: true,
            });
            if (footers.length > 1) {
                window.console.warn("GKMenu - more than one footer provided, only the first will be rendered");
            }
            if (headers.length > 1) {
                window.console.warn("GKMenu - more than one header provided, only the first will be rendered");
            }
            _this.setState({
                footer: footers.length > 0 ? footers[0] : undefined,
                header: headers.length > 0 ? headers[0] : undefined,
                menuItems: menuItems,
            });
        };
        // Render the menu. Used by both fullscreen and regular renderers.
        _this.renderMenu = function () {
            var _a = _this.state, activeChild = _a.activeChild, footer = _a.footer, header = _a.header, menuItems = _a.menuItems;
            var passThroughProps = {
                className: _this.props.className,
                "data-qa": _this.props["data-qa"],
                id: _this.uniqueId,
                style: _this.props.style,
            };
            return (React.createElement("div", __assign({}, (0, common_1.mapDefaultProps)(passThroughProps, {
                _gkComponentName: "gk-menu",
                className: [
                    footer && "gk-menu-has-footer",
                    header && "gk-menu-has-header",
                    _this.props.compact && "compact",
                ]
                    .filter(function (c) { return c; })
                    .join(" "),
            }), { ref: _this.menuRef, role: "dialog" }),
                header,
                React.createElement("ul", { className: "gk-menu-items", role: "menu", "aria-activedescendant": activeChild ? activeChild.uniqueId : undefined, tabIndex: -1, onFocus: _this.onMenuFocused, onBlur: _this.onMenuBlurred, onClick: _this.onItemSelected, onKeyDown: _this.keyboardController.keyEventHandler, ref: _this.menuListAvaialable },
                    menuItems,
                    React.createElement(GKMenuLoading_1.GKMenuLoading, { isLoading: _this.props.isLoading })),
                footer || null));
        };
        _this.setDocumentListeners = function (add) {
            if (add) {
                document.documentElement.addEventListener("touchend", _this.onTouchend);
                document.documentElement.addEventListener("mousedown", _this.onClickOutside);
            }
            else {
                document.documentElement.removeEventListener("touchend", _this.onTouchend);
                document.documentElement.removeEventListener("mousedown", _this.onClickOutside);
            }
        };
        // Used to size the menu container to fit within the screen area.
        // NOTE: this might be outdated in popper 2; we should look into
        // "boundary" and "altBoundary" in the future.
        _this.autoSizing = function (_a) {
            var _b, _c;
            var state = _a.state;
            var maxSafeHeight = 450;
            // scrollParent is the closest ancestor that can cut off the menu
            var scrollParent = (_b = state.scrollParents) === null || _b === void 0 ? void 0 : _b.reference[0];
            // If we can't get a clientHeight (undefined/incompatible parent),
            // default to window.innherHeight (previous behavior)
            var wHeight = ((_c = scrollParent) === null || _c === void 0 ? void 0 : _c.clientHeight) || window.innerHeight;
            var rRect = state.rects.reference;
            var rBottom = rRect.height + rRect.y;
            state.styles.popper.display = "flex";
            state.styles.popper.flexDirection = "column";
            var maxHeight = "";
            if (state.placement.includes("bottom")) {
                maxHeight = Math.min(maxSafeHeight, Math.floor(wHeight - rBottom)) + "px";
            }
            else if (state.placement.includes("top")) {
                maxHeight = Math.min(maxSafeHeight, Math.floor(rRect.y)) + "px";
            }
            state.styles.popper.maxHeight = maxHeight;
            return state;
        };
        _this.state = {
            activeChild: null,
            hasFocus: false,
            isOpen: false,
            menuItems: [],
        };
        _this.keyboardController = new models_1.KeyboardNavigationController((_a = {},
            _a[models_1.NavigationKey.ArrowDown] = _this.next,
            _a[models_1.NavigationKey.ArrowUp] = _this.previous,
            _a[models_1.NavigationKey.End] = _this.last,
            _a[models_1.NavigationKey.Enter] = _this.selectFocusedItem,
            _a[models_1.NavigationKey.Escape] = _this.close,
            _a[models_1.NavigationKey.Home] = _this.first,
            _a[models_1.NavigationKey.PageDown] = _this.last,
            _a[models_1.NavigationKey.PageUp] = _this.first,
            _a), {
            preventDefault: true,
        });
        return _this;
    }
    Object.defineProperty(GKMenu.prototype, "navigator", {
        get: function () {
            return this.pvtNavigator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GKMenu.prototype, "isManagingOwnFocus", {
        get: function () {
            return this.props.autoFocus !== undefined ? this.props.autoFocus : true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GKMenu.prototype, "closeOnSelect", {
        get: function () {
            return this.props.closeOnSelect !== undefined
                ? this.props.closeOnSelect
                : true;
        },
        enumerable: false,
        configurable: true
    });
    // COMPONENT LIFECYCLE --------------------------------------------
    GKMenu.prototype.componentDidMount = function () {
        this.processChildren();
        if (this.props.isOpen) {
            this.openMenu();
        }
        if (this.isManagingOwnFocus) {
            this.setDocumentListeners(true);
        }
    };
    GKMenu.prototype.componentWillUnmount = function () {
        this.setDocumentListeners(false);
    };
    GKMenu.prototype.componentDidUpdate = function (oldProps, oldState) {
        if (this.props.children !== oldProps.children) {
            if (this.updatePosition) {
                this.updatePosition();
            }
        }
        if (oldProps.autoFocus !== this.props.autoFocus) {
            this.setDocumentListeners(this.props.autoFocus);
        }
        if (oldProps.children !== this.props.children) {
            this.navigator.exit();
            this.processChildren();
        }
        if (this.props.isOpen !== oldProps.isOpen) {
            if (this.props.isOpen) {
                this.openMenu();
            }
            else {
                this.closeMenu();
            }
        }
        if (this.state.activeChild !== oldState.activeChild) {
            if (oldState.activeChild) {
                oldState.activeChild.setVirtualFocus(false);
            }
            if (this.state.activeChild) {
                this.state.activeChild.setVirtualFocus(true);
            }
            // set virtual selection and scroll to it
            // TODO: need to replace call to document with a wrapper or ReactDOM call
            if (this.state.activeChild) {
                var element = document.getElementById(this.state.activeChild.uniqueId);
                if (element) {
                    (0, scroll_into_view_1.default)(element, {
                        validTarget: function (target, parentsScrolled) { return parentsScrolled <= 1; },
                    });
                }
            }
        }
    };
    GKMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, anchorRef = _a.anchorRef, anchoredTo = _a.anchoredTo, enforcePlacement = _a.enforcePlacement, fullscreenCloseText = _a.fullscreenCloseText;
        var refElement;
        var dummyRefId = this.uniqueId + "-ref";
        if (anchorRef) {
            refElement = anchorRef.current;
        }
        else if (anchoredTo) {
            refElement = document.getElementById(anchoredTo) || undefined;
        }
        return (React.createElement(common_1.WindowSizeContext.Consumer, null, function (_a) {
            var isMobileSized = _a.isMobileSized;
            return (React.createElement(React.Fragment, null,
                !refElement && React.createElement("div", { id: dummyRefId }),
                isMobileSized ? (React.createElement(__1.FullscreenOverlay, { isOpen: _this.state.isOpen },
                    React.createElement(__1.GKButton, { onClick: _this.closeMenu, className: "menu-close popover-close", color: "link" },
                        React.createElement("span", { "aria-hidden": "true" },
                            React.createElement(__1.GKIcon, { name: __1.GKIconName.KeyboardArrowLeft }),
                            fullscreenCloseText || "Back")),
                    _this.renderMenu())) : _this.state.isOpen ? (React.createElement(react_popper_1.Popper, { placement: _this.props.placement || "bottom", referenceElement: refElement || document.getElementById(dummyRefId) || undefined, strategy: "fixed", modifiers: [
                        { name: "flip", enabled: !enforcePlacement },
                        { name: "hide", enabled: false },
                        { name: "preventOverflow", enabled: false },
                        {
                            // 'autoSizing' - custom modifier to ensure popper stays visible in viewport
                            enabled: true,
                            fn: _this.autoSizing,
                            name: "autoSizing",
                            phase: "beforeWrite",
                            requires: ["computeStyles"],
                        },
                    ] }, function (_a) {
                    var ref = _a.ref, style = _a.style, placement = _a.placement, update = _a.update;
                    _this.updatePosition = update;
                    return (React.createElement("div", { ref: ref, style: __assign(__assign({ minWidth: refElement ? refElement.clientWidth : "auto", zIndex: 1000 }, style), _this.props.style), "data-placement": placement }, _this.renderMenu()));
                })) : null));
        }));
    };
    return GKMenu;
}(common_1.GKPureComponent));
exports.GKMenu = GKMenu;
exports.default = GKMenu;
